import { Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'
import { FC } from 'react'

const Labels: FC<{ customLeft?: string; customRight?: string }> = ({ customLeft, customRight }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 1,
                width: '100%',
            }}
        >
            <Text variant={'button'} sx={{ width: '45%' }}>
                {customLeft || 'Columns in your file'}
            </Text>
            <Box />
            <Text className={'labels__right'} variant={'button'} sx={{ width: '45%' }}>
                {customRight || 'Lune fields'}
            </Text>
        </Box>
    )
}

export default Labels
